import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedStops } from '../../store/selectors/ui/routeDetail';
import { getRouteDetail } from '../../store/selectors/route';
import stopListColumns from '../../components/RouteDetail/StopList/stopListColumns';
import { transferStopListColumnsConfigs } from '../../enums/columnsConfigs';
import { prepareTableData } from '../routeDetail/model';

export default (headerCellClasses, bodyCellClasses) => {
  const selectedStops = useSelector(getSelectedStops);
  const route = useSelector(getRouteDetail);

  return useMemo(
    () => ({
      columns: stopListColumns({
        route,
        columnsConfigs: transferStopListColumnsConfigs,
        headerCellClasses,
        bodyCellClasses,
      }),
      data: prepareTableData(selectedStops),
    }),
    [headerCellClasses, bodyCellClasses, selectedStops, route]
  );
};
